import React from "react";

function Projects(props) {
    return (
    <div className="relative flex flex-col-reverse px-8 py-8 mx-auto lg:block lg:flex-col lg:py-18
        xl:py-42 md:px-12 sm:max-w-xl md:max-w-full">
        <div className="z-0 flex justify-center h-full -mx-4 overflow-hidden lg:pt-24 lg:pb-16 lg:pr-8
             xl:pr-0 lg:w-1/2 lg:absolute lg:justify-end lg:bottom-0 lg:left-0 lg:items-center">
            <img
                src={props.image}
                className="object-cover object-right w-full h-auto lg:w-auto lg:h-full sm:w-auto sm:h-full"
                alt=""
            />
        </div>
        <div className="relative flex justify-end max-w-xl mx-auto xl:pr-32 lg:max-w-screen-xl">
            <div className="mb-16 lg:pr-5 lg:max-w-lg lg:mb-0">
                <div className="max-w-xl mb-6">
                    <h2 className="max-w-lg mb-6 font-sans text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl sm:leading-none">
                        {props.title}
                        <br />
                        {props.subtitle}
                    </h2>
                    <p className="text-base text-gray-700 md:text-lg">
                        {props.description}
                    </p>
                </div>
            </div>
        </div>
    </div>
    )
}
export default Projects
